import {PPSettings} from '@gongxigames/framework/integrations/pariplay/PPSettings';

export class PPConfiguration {
    public roundDelay = 3100;
    public ClientToken: string;
    public GameCode: string;
    public CurrencyCode: string;
    public LanguageCode: string;
    public RgsUrl: string;
    /**
     * PP logic sends either <b>ExtraData</b> or <b>extraData</b> parameter.
     * As HTTP parameters are case sensitive, the client has to store
     * and send it back with loadgame request in the exact same case
     */
    public ExtraData: string;
    /**
     * @see ExtraData
     */
    public extraData: string;
    public HomeUrl: string;
    public CashierUrl: string;
    public disableFullScreen: boolean;
    public sound: number;
    public playerTokenID!: string;
    public BalanceURL!: string;
    public EndFreeGameUrl!: string;
    public EndUrl!: string;
    public NotifyUrl!: string;
    public PlaceBetUrl!: string;
    public HistoryUrl: string;
    public RegulationTypeFromURL: string | undefined;
    public ticketID!: number;
    public DefaultStake!: number;
    public DefaultBet!: number;

    public static convertDoubleToInt(value: number): number {
        return Math.round(value * 1000);
    }

    public static convertIntToDouble(value: number): string {
        return (value / 1000).toFixed(3);
    }

    constructor(settings: PPSettings) {
        this.ClientToken = settings.get('token')!;
        this.GameCode = settings.get('gameCode')!;
        this.CurrencyCode = settings.get('currencyCode')!;
        this.LanguageCode = settings.get('lang')!;
        this.RgsUrl = settings.get('rgsUrl')!;
        this.ExtraData = settings.get('ExtraData');
        this.extraData = settings.get('extraData');
        this.HomeUrl = settings.get('homeUrl')!;
        this.CashierUrl = settings.get('cashierUrl')!;
        this.HistoryUrl = settings.get('historyUrl')!;
        this.RegulationTypeFromURL = settings.get('regulationType');

        const sound = settings.get('sound');

        this.disableFullScreen = settings.get('disableFullScreen');
        this.sound = sound !== undefined ? sound : undefined!;
    }
}
